export class Usuario {
  idUsuario: number;
  habilitado: boolean;
  nombre: string;
  telefono: string;
  correo: string;
  urlFoto: string;
  fechaCaptura: Date;
  claveTelefono: string;
  password?: string;
  alias: string;
  pais: Pais;
  tarjetaPortada: TarjetaPortada;
  puesto: Puesto;
  empresa: Empresa;
  editarTarjeta: boolean;
  crearTarjeta: boolean;
  iniciarSesion: boolean;
  esVIP: boolean;
  visitas?: number = 0;
  ultimaVisita?: Visita | null = null;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  constructor() {
    this.idUsuario = 0;
    this.habilitado = false;
    this.esVIP = false;
    this.nombre = '';
    this.password = '';
    this.telefono = '';
    this.correo = '';
    this.urlFoto = '';
    this.fechaCaptura = new Date();
    this.claveTelefono = '';
    this.alias = '';
    this.pais = new Pais();
    this.tarjetaPortada = new TarjetaPortada();
    this.puesto = new Puesto();
    this.empresa = new Empresa();
    this.editarTarjeta = false;
    this.crearTarjeta = false;
    this.iniciarSesion = false;
  }
}

export class Visita {
  idVisita: number = 0;
  idTarjeta: number = 0;
  fecha: Date | null = null;
}

class Empresa {
  idEmpresa: number;
  descripcion: string;
  configuracionEmpresa: ConfiguracionEmpresa;
  constructor() {
    this.idEmpresa = 0;
    this.descripcion = '';
    this.configuracionEmpresa = new ConfiguracionEmpresa();
  }
}

class ConfiguracionEmpresa {
  idConfiguracion: number;
  colorTarjeta: string;
  colorLetra: string;
  fondoFlecha: string;
  colorFlecha: string;
  urlBanner: string;
  esHorizontal: boolean;
  urlLogotipo: string;
  fechaCaptura: Date;
  fechaModificacion: Date;
  constructor() {
    this.idConfiguracion = 0;
    this.esHorizontal = false;
    this.colorTarjeta = '';
    this.colorLetra = '';
    this.fondoFlecha = '';
    this.colorFlecha = '';
    this.urlBanner = '';
    this.urlLogotipo = '';
    this.fechaCaptura = new Date();
    this.fechaModificacion = new Date();
  }
}

class Pais {
  idPais: number;
  Abreviatura: string;
  Descripcion: string;
  constructor() {
    this.idPais = 0;
    this.Abreviatura = '';
    this.Descripcion = '';
  }
}

class Puesto {
  idTipoPuestoUsuario: number;
  descripcion: string;
  llave: string;
  constructor() {
    this.idTipoPuestoUsuario = 0;
    this.descripcion = '';
    this.llave = '';
  }
}

class RedSocial {
  idRedSocial: number = 0;
  redSocial: string = '';
}

class RedesSociales {
  idRedTarjeta: number;
  urlRedSocial: string;
  fechaCaptura: Date;
  fechaModifica: Date;
  redSocial: RedSocial;
  constructor() {
    this.idRedTarjeta = 0;
    this.urlRedSocial = '';
    this.fechaCaptura = new Date();
    this.fechaModifica = new Date();
    this.redSocial = new RedSocial();
  }
}

class TarjetaPortadaDetalle {
  idTarjeta: number;
  titulo: string;
  urlLogo: string;
  correoProfesional: string;
  claveTelefono: string;
  telefono: string;
  domicilio: string;
  descripcion: string;
  fechaCaptura: Date;
  fechaModifica: Date;
  visitas: number;
  constructor() {
    this.idTarjeta = 0;
    this.titulo = '';
    this.urlLogo = '';
    this.correoProfesional = '';
    this.claveTelefono = '';
    this.telefono = '';
    this.domicilio = '';
    this.descripcion = '';
    this.fechaCaptura = new Date();
    this.fechaModifica = new Date();
    this.visitas = 0;
  }
}

export class TarjetaPortada {
  idTarjeta: number;
  nombre: string;
  profesion: string;
  descripcionTarjeta: string;
  urlFotoPerfil: string;
  urlBanner: string;
  colorTarjeta: string;
  habilitado: boolean;
  fechaCaptura: Date;
  fechaModifica: Date;
  colorLetra: string;
  esHorizontal: boolean;
  urlLogotipo: string;
  popup: boolean = false;
  colorFlecha: string;
  fondoFlecha: string;
  Empresa: string;
  colorFlechaD: string;
  fondoFlechaD: string;
  redesSociales: RedesSociales[];
  tarjetaPortadaDetalle: TarjetaPortadaDetalle;

  popUpHabilitado: number;
  tituloHabilitado: number;
  tituloPopUp: string; 
  preguntaHabilitado: number;
  pregunta: string;
  respuestas: any;
  imagenUrl: string;
  redHabilitado: boolean;

  constructor() {
    this.idTarjeta = 0;
    this.nombre = '';
    this.profesion = '';
    this.esHorizontal = false;
    this.descripcionTarjeta = '';
    this.urlFotoPerfil = '';
    this.urlBanner = '';
    this.colorTarjeta = '';
    this.habilitado = false;
    this.fechaCaptura = new Date();
    this.fechaModifica = new Date();
    this.colorLetra = '';
    this.urlLogotipo = '';
    this.colorFlecha = '';
    this.fondoFlecha = '';
    this.Empresa = '';
    this.colorFlechaD = '';
    this.fondoFlechaD = '';
    this.redesSociales = [];
    this.tarjetaPortadaDetalle = new TarjetaPortadaDetalle();
    this.popup = false;
    this.popUpHabilitado = 0;
    this.tituloHabilitado = 0;
    this.tituloPopUp = '';
    this.preguntaHabilitado = 0;
    this.pregunta = '';
    this.respuestas = [];
    this.imagenUrl = '';
    this.redHabilitado = false;
  }
}
